// extracted by mini-css-extract-plugin
export default {"loadingDialog":"LoadingScreen_loadingDialog__5EqQw"};